import { render, staticRenderFns } from "./tiaoma.vue?vue&type=template&id=b6568b0c&scoped=true&"
import script from "./tiaoma.vue?vue&type=script&lang=js&"
export * from "./tiaoma.vue?vue&type=script&lang=js&"
import style0 from "./tiaoma.vue?vue&type=style&index=0&id=b6568b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6568b0c",
  null
  
)

export default component.exports